import React from "react";
import { useParams } from "react-router-dom";

import BlockPage from "components/pages/BlockLocation/Block";

const Block = () => {
  const { id } = useParams();

  return <BlockPage id={id} />;
};

export default Block;
